import React from "react";
import SEO from "components/SEO/SEO";
import "./Awards.css";

const AWARDS = [
  {
    badge: "🏆", bank: "IDFC FIRST Bank", year: "Q1 FY25",
    title: "Champion of the Quarter — Platinum Achiever",
    desc: "CSR Associates received the 'Champion of the Quarter' award from IDFC FIRST Bank for exceptional performance in Q1 FY25. Awarded Platinum Achiever status for outstanding performance, delivery, and quality of service in credit card recovery — confirmed by the Head of Retail Desk and Head of Debt Management.",
  },
  {
    badge: "⭐", bank: "Kotak Mahindra Bank", year: "2024",
    title: "Outstanding Quarterly Performance Award",
    desc: "Recognised by Kotak Mahindra Bank for exceptional performance in Bucket 5 & 6 credit card collections. This certification acknowledges CSR Associates' dedication to excellence in banking operations and consistent results in the financial services sector.",
  },
  {
    badge: "🤝", bank: "FPL Technologies (One Card)", year: "2021–2024",
    title: "Three Years of Excellence — Partnership Award",
    desc: "Honoured by FPL Technologies (One Card) with a partnership excellence award for three consecutive years of outstanding collaboration and service delivery. This recognition celebrates sustained commitment, reliability, and exceptional partnership standards throughout 2021–2024.",
  },
  {
    badge: "🥇", bank: "Slice", year: "Q1 2024",
    title: "Best Agency Partner — Q1 2024",
    desc: "Recognised as the Best Agency Partner by Slice for outstanding performance in Q1 2024. This award celebrates CSR Associates' exceptional service delivery, strategic collaboration, and remarkable contributions to Slice's business objectives — setting benchmarks in agency partnership excellence.",
  },
];

export default function Awards() {
  return (
    <>
      <SEO
        title="Awards & Recognition | CSR Associates — Debt Recovery Excellence"
        description="CSR Associates award-winning debt recovery. Recognised by IDFC First Bank, Kotak Mahindra, FPL Technologies and Slice for outstanding collections performance."
        keywords="CSR Associates awards, debt recovery awards india, collections agency recognition bangalore"
      />
      <div className="awards-page">
        <div className="container" style={{ maxWidth: 1200, margin: "0 auto", padding: "80px 24px" }}>

          <div className="page-hero" data-aos="fade-up">
            <span className="page-hero-tag">Recognition</span>
            <h1 className="page-hero-title">
              Awards & <em>Achievements</em>
            </h1>
            <p className="page-hero-sub">
              Industry recognition from India's most trusted banks, NBFCs, and fintechs —
              a testament to consistent results and ethical operations.
            </p>
            <div className="page-hero-divider" />
          </div>

          {/* Awards Grid */}
          <div className="awards-grid">
            {AWARDS.map((award, i) => (
              <article key={i} className="award-card" data-aos="fade-up" data-aos-delay={i * 100}>
                <div className="award-card-header">
                  <span className="award-badge">{award.badge}</span>
                  <div>
                    <div className="award-bank">{award.bank}</div>
                    <div className="award-year">{award.year}</div>
                  </div>
                </div>
                <h3 className="award-title">{award.title}</h3>
                <p className="award-desc">{award.desc}</p>
              </article>
            ))}
          </div>

          {/* Case Study */}
          <div className="case-study-section" data-aos="fade-up">
            <div className="eyebrow">Our Approach</div>
            <h2 className="section-heading" style={{ marginBottom: "20px" }}>
              Case Study <span className="accent">Responsibility</span>
            </h2>
            <div className="case-study-content">
              <p>
                At CSR Associates, we take pride in every engagement. Our track record demonstrates
                measurable improvements in debt recovery rates, customer satisfaction, and financial
                transparency — achieved through data-driven strategies and a human-centric approach.
              </p>
              <p>
                Each partnership is built on trust, transparency, and a deep understanding of our
                clients' unique challenges. Our team of dedicated professionals brings together
                12+ years of expertise, modern technology, and a customer-first mindset to every
                project — continuously refining our methodologies to stay ahead of market trends
                and RBI regulatory requirements.
              </p>
              <p>
                What sets us apart is our holistic approach: we don't just solve immediate collection
                challenges, we build frameworks for long-term sustainable recovery. Our commitment to
                ethical practices ensures every interaction reflects our core values of respect,
                fairness, and professionalism — protecting our clients' brand reputation while
                delivering outstanding recovery outcomes.
              </p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
